// Calendar version (YYYY.DDD.PATCH), shared scheme with @vibgrate/cli.
export const VERSION = '2026.704.1';
